// The words grouped mode owns: its result count, which counts matching rows across every group, collapsed
// sections included. Loading, zero results and error read as the ungrouped count does.

/**
 * @param {(key: string, values?: object) => string} text the registry's copy lookup
 * @param {{status: string, total: number}} values
 * @returns {string} empty when there is no count to announce
 */
export const groupedCountText = (text, { status, total }) => {
  if (status === 'loading') return text('strTableLoading')
  if (status === 'error') return ''
  if (!total) return text('strTableNoResults')
  return total === 1 ? '1 result' : `${total} results`
}
